import React from 'react';

const NotificationBadge = ({ 
  count = 0, 
  showZero = false, 
  maxCount = 99,
  size = 'default',
  variant = 'primary',
  className = '',
  children 
}) => {
  const shouldShow = count > 0 || showZero;
  const displayCount = count > maxCount ? `${maxCount}+` : count?.toString();
  
  const sizeClasses = {
    sm: 'min-w-[16px] h-4 text-[10px] px-1',
    default: 'min-w-[20px] h-5 text-xs px-1.5',
    lg: 'min-w-[24px] h-6 text-sm px-2'
  };
  
  const variantClasses = {
    primary: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
    success: 'bg-success text-success-foreground',
    warning: 'bg-warning text-warning-foreground',
    error: 'bg-error text-error-foreground',
    muted: 'bg-muted text-muted-foreground'
  };

  if (!shouldShow && !children) return null;

  return (
    <div className="relative inline-flex">
      {children}
      {shouldShow && (
        <span 
          className={`
            absolute -top-1 -right-1 inline-flex items-center justify-center
            rounded-full font-medium leading-none
            ${sizeClasses?.[size]}
            ${variantClasses?.[variant]}
            ${className}
            animate-fade-in
          `}
        >
          {displayCount}
        </span>
      )}
    </div>
  );
};

export default NotificationBadge;